// extracted by mini-css-extract-plugin
export var chevron = "_16-d";
export var disabled = "_16-b";
export var error = "_16-c";
export var hideBorder = "_16-1";
export var icon = "_16-e";
export var input = "_16-0";
export var open = "_16-9";
export var placeholder = "_16-a";
export var regular = "_16-5";
export var singleRowInput = "_16-2";
export var singleSelectInput = "_16-3 _16-0";
export var small = "_16-4";
export var spinnerContainer = "_16-g";
export var tag = "_16-7";
export var tagsContainer = "_16-8";
export var tagsInput = "_16-6 _16-0";
export var xSmall = "_16-f";